import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Menu, X, Globe } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const {
    t,
    language,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'pl' : 'en');
  };
  const navLinks = [{
    name: t.nav.about,
    href: '#about'
  }, {
    name: t.nav.services,
    href: '#services'
  }, {
    name: t.nav.calendar,
    href: '#calendar'
  }, {
    name: t.nav.contact,
    href: '#contact'
  }, {
    name: t.nav.terms,
    href: '#terms'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-[#FAF7F5]/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-154">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        <div className="flex justify-between items-center" data-id="element-156">
          {/* Logo */}
          <a href="#" className="font-heading text-2xl md:text-3xl font-bold text-[#3D3D3D]" data-id="element-157">
            Glow Studio
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-158">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-[#3D3D3D] hover:text-[#8B7E74] transition-colors font-medium text-sm tracking-wide" data-id="element-159">
                {link.name}
              </a>)}

            <button onClick={toggleLanguage} className="flex items-center space-x-1 text-[#3D3D3D] hover:text-[#8B7E74] transition-colors" aria-label="Toggle language" data-id="element-160">
              <Globe size={18} data-id="element-161" />
              <span className="uppercase text-sm font-medium" data-id="element-162">{language}</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center space-x-4" data-id="element-163">
            <button onClick={toggleLanguage} className="flex items-center space-x-1 text-[#3D3D3D]" data-id="element-164">
              <span className="uppercase text-sm font-medium" data-id="element-165">{language}</span>
            </button>
            <button onClick={() => setIsOpen(!isOpen)} className="text-[#3D3D3D] focus:outline-none" data-id="element-166">
              {isOpen ? <X size={24} data-id="element-167" /> : <Menu size={24} data-id="element-168" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-169">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#FAF7F5] border-t border-gray-100" data-id="element-170">
            <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-171">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-3 text-base font-medium text-[#3D3D3D] hover:bg-[#E8D5D5]/30 rounded-md" data-id="element-172">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}